import { inject } from '@angular/core';
import { ActivatedRouteSnapshot, CanActivateFn, Router } from '@angular/router';
import { WINDOW } from '@campus/browser';
import { ENVIRONMENT_BASE_PATH_TOKEN } from '@campus/environment';
import { DateFunctions } from '@campus/utils';

export const archiveRedirectGuard: CanActivateFn = (route: ActivatedRouteSnapshot) => {
  const router = inject(Router);
  const window = inject(WINDOW);

  const archiveYear = route.paramMap.get('archiveYear');
  if (!archiveYear) return false;

  // this makes use of the cloudfront error page: when the route `/<year>/index.html` is picked up by the parent app (non-archive),
  // it means that there was no file served at `/<year>/index.html`, which means the app was not yet deployed to the archive `<year>` folder
  const isIndexHtml = window.location.href?.endsWith('index.html');
  if (isIndexHtml) return router.parseUrl('/v2/error/404'); // archive doesn't exist yet for this year

  const currentSchoolYear = DateFunctions.getSchoolYearFromTransitionPeriod();

  let url = inject(ENVIRONMENT_BASE_PATH_TOKEN);
  if (archiveYear === currentSchoolYear.toString()) {
    window.sessionStorage.removeItem('archiveYear');
    url += '/';
  } else {
    window.sessionStorage.setItem('archiveYear', archiveYear);
    url += `/${archiveYear}/index.html`;
  }

  window.location.assign(url ?? '/');

  return false;
};
